import _ from 'lodash';
import { axiosInstance } from '../helpers';
import { userService } from './user.service';

const handleResponse = response => {
  const data = response.data;
  if (!_.includes([200, 201, 204], response.status)) {
    if (response.status === 401 && !response.config.url.includes('/users/login')) {
      // auto logout if 401 response returned from api
      userService.logout().then(() => window.location.reload(true));
    }

    const error = (data && data.message) || response.statusText;

    // eslint-disable-next-line no-throw-literal
    throw { status: response.status, error };
  }

  return data;
};

const findAll = () => {
  return axiosInstance
    .get(`/coupons`)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

const create = coupon => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: coupon,
  };

  return axiosInstance
    .post(`/coupons`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
};



export const couponService = {
  findAll,
  create,
};
